import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/iletisim/page.tsx");
